<template>
    <div
        class="grid grid-cols-3 border border-gray-200 divide-x divide-gray-200 dark:border-neutral-800 dark:divide-neutral-900"
    >
        <div
            class="relative p-4 text-gray-600 transition-colors duration-300 bg-white cursor-pointer dark:text-neutral-300 dark:bg-neutral-800 group dark:aria-selected:bg-teal-700 aria-selected:bg-teal-100 aria-selected:text-teal-950 dark:aria-selected:text-teal-50"
            :aria-selected="modelValue === 'simple'"
            @click="modelValue = 'simple'"
        >
            <div
                class="absolute hidden rotate-45 -translate-x-full -translate-y-1/2 bg-(--color-bg-base) left-1/2 top-full group-aria-selected:block size-4"
            ></div>
            <icon icon="fa/solid/box" class="size-6"></icon>
            <h4 class="text-sm font-semibold">{{ lang(`${langPrefix}.wizard.types.simple`) }}</h4>
            <p class="text-xs">
                {{ lang(`${langPrefix}.wizard.types.simple_help`) }}
            </p>
        </div>
        <div
            class="relative p-4 text-gray-600 transition-colors duration-300 bg-white cursor-pointer dark:text-neutral-300 dark:bg-neutral-800 group dark:aria-selected:bg-orange-700 aria-selected:bg-orange-100 aria-selected:text-orange-950 dark:aria-selected:text-orange-50"
            :aria-selected="modelValue === 'configuration'"
            @click="modelValue = 'configuration'"
        >
            <div
                class="absolute hidden rotate-45 -translate-x-full -translate-y-1/2 bg-(--color-bg-base) left-1/2 top-full group-aria-selected:block size-4"
            ></div>
            <icon icon="fa/solid/box-taped" class="size-6"></icon>
            <h4 class="text-sm font-semibold">{{ lang(`${langPrefix}.wizard.types.configuration`) }}</h4>
            <p class="text-xs">
                {{ lang(`${langPrefix}.wizard.types.configuration_help`) }}
            </p>
        </div>
        <div
            class="relative p-4 text-gray-600 transition-colors duration-300 bg-white cursor-pointer dark:text-neutral-300 dark:bg-neutral-800 group dark:aria-selected:bg-blue-700 aria-selected:bg-blue-100 aria-selected:text-blue-950 dark:aria-selected:text-blue-50"
            :aria-selected="modelValue === 'copy'"
            @click="modelValue = 'copy'"
        >
            <div
                class="absolute hidden rotate-45 -translate-x-full -translate-y-1/2 bg-(--color-bg-base) left-1/2 top-full group-aria-selected:block size-4"
            ></div>
            <icon icon="fa/solid/boxes-packing" class="size-6"></icon>
            <h4 class="text-sm font-semibold">{{ lang(`${langPrefix}.wizard.types.copy`) }}</h4>
            <p class="text-xs">
                {{ lang(`${langPrefix}.wizard.types.copy_help`) }}
            </p>
        </div>
    </div>
</template>

<script setup lang="ts">
const modelValue = defineModel({
    type: String,
    default: 'simple',
});

const langPrefix = 'products::products';
</script>
